module.exports = __webpack_public_path__ + "img/IMG_1156_FoamcoreMatted.e6473e45.jpg";